import { render, staticRenderFns } from "./p1s1c1c2ProfileSummary.vue?vue&type=template&id=1ae278f8&scoped=true"
import script from "./p1s1c1c2ProfileSummary.vue?vue&type=script&lang=js"
export * from "./p1s1c1c2ProfileSummary.vue?vue&type=script&lang=js"
import style0 from "./p1s1c1c2ProfileSummary.vue?vue&type=style&index=0&id=1ae278f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae278f8",
  null
  
)

export default component.exports